


class Device_replace {
    constructor() {};

    public main(): void {
        let mql: MediaQueryList = window.matchMedia('screen and (max-width: 500px)');//切り替わる時に一度だけ実行できる。window.matchMedia Internet Explorer 10
        let node: NodeListOf<Element> = document.querySelectorAll(".js-replace");//NodeList
        let $rep = [].slice.call(node);//NodeList ie未対応
        let flag: boolean = false;
        let type: string = "";
        let reg: RegExp = /(.*)(?:\.([^.]+$))/;

        function checkBreakPoint(mql: any): void {
            if (mql.matches) {
                // スマホ向け
                if (window.innerWidth <= 750) {
                    $rep.forEach(function (index: any) {
                        type = index.getAttribute("src").match(reg)[2];
                        index.setAttribute("src", index.getAttribute("src").replace("." + type, "_sp." + type));
                    });
                    flag = true;
                }
            } else {
                // PC向け
                if (flag == true) {
                    $rep.forEach(function (index: any) {
                        type = index.getAttribute("src").match(reg)[2];
                        index.setAttribute("src", index.getAttribute("src").replace("_sp." + type, "." + type));
                    });
                    flag = false;
                }

            }
        }

        // ブレイクポイントの瞬間に発火
        mql.addListener(checkBreakPoint);

        // 初回チェック
        checkBreakPoint(mql);

    }


}

export default Device_replace;